import _objectWithoutProperties from "D:\\bosscar\\bosscarsoft16\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "D:\\bosscar\\bosscarsoft16\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var _excluded = ["height", "width", "redraw", "datasetIdKey", "type", "data", "options", "plugins", "fallbackContent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useRef, useEffect } from 'react';
import { Chart as Chart$1, LineController, BarController, RadarController, DoughnutController, PolarAreaController, BubbleController, PieController, ScatterController } from 'chart.js';
var defaultDatasetIdKey = 'label';
function reforwardRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function setOptions(chart, nextOptions) {
  chart.options = _objectSpread({}, nextOptions);
}
function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
  var datasetIdKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultDatasetIdKey;
  var addedDatasets = [];
  currentData.datasets = nextDatasets.map(function (nextDataset) {
    // given the new set, find it's current match
    var currentDataset = currentData.datasets.find(function (dataset) {
      return dataset[datasetIdKey] === nextDataset[datasetIdKey];
    });
    // There is no original to update, so simply add new one
    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return _objectSpread({}, nextDataset);
    }
    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}
function cloneData(data) {
  var datasetIdKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDatasetIdKey;
  var nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data.labels);
  setDatasets(nextData, data.datasets, datasetIdKey);
  return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */
function getDatasetAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
    intersect: true
  }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */
function getElementAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
    intersect: true
  }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */
function getElementsAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
    intersect: true
  }, false);
}
function ChartComponent(_ref, ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 150 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 300 : _ref$width,
    _ref$redraw = _ref.redraw,
    redraw = _ref$redraw === void 0 ? false : _ref$redraw,
    datasetIdKey = _ref.datasetIdKey,
    type = _ref.type,
    data = _ref.data,
    options = _ref.options,
    _ref$plugins = _ref.plugins,
    plugins = _ref$plugins === void 0 ? [] : _ref$plugins,
    fallbackContent = _ref.fallbackContent,
    props = _objectWithoutProperties(_ref, _excluded);
  var canvasRef = useRef(null);
  var chartRef = useRef();
  var renderChart = function renderChart() {
    if (!canvasRef.current) return;
    chartRef.current = new Chart$1(canvasRef.current, {
      type: type,
      data: cloneData(data, datasetIdKey),
      options: options,
      plugins: plugins
    });
    reforwardRef(ref, chartRef.current);
  };
  var destroyChart = function destroyChart() {
    reforwardRef(ref, null);
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };
  useEffect(function () {
    if (!redraw && chartRef.current && options) {
      setOptions(chartRef.current, options);
    }
  }, [redraw, options]);
  useEffect(function () {
    if (!redraw && chartRef.current) {
      setLabels(chartRef.current.config.data, data.labels);
    }
  }, [redraw, data.labels]);
  useEffect(function () {
    if (!redraw && chartRef.current && data.datasets) {
      setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }
  }, [redraw, data.datasets]);
  useEffect(function () {
    if (!chartRef.current) return;
    if (redraw) {
      destroyChart();
      setTimeout(renderChart);
    } else {
      chartRef.current.update();
    }
  }, [redraw, options, data.labels, data.datasets]);
  useEffect(function () {
    renderChart();
    return function () {
      return destroyChart();
    };
  }, []);
  return /*#__PURE__*/React.createElement("canvas", Object.assign({
    ref: canvasRef,
    role: "img",
    height: height,
    width: width
  }, props), fallbackContent);
}
var Chart = /*#__PURE__*/forwardRef(ChartComponent);
function createTypedChart(type, registerables) {
  Chart$1.register(registerables);
  return /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(Chart, Object.assign({}, props, {
      ref: ref,
      type: type
    }));
  });
}
var Line = /* #__PURE__ */createTypedChart('line', LineController);
var Bar = /* #__PURE__ */createTypedChart('bar', BarController);
var Radar = /* #__PURE__ */createTypedChart('radar', RadarController);
var Doughnut = /* #__PURE__ */createTypedChart('doughnut', DoughnutController);
var PolarArea = /* #__PURE__ */createTypedChart('polarArea', PolarAreaController);
var Bubble = /* #__PURE__ */createTypedChart('bubble', BubbleController);
var Pie = /* #__PURE__ */createTypedChart('pie', PieController);
var Scatter = /* #__PURE__ */createTypedChart('scatter', ScatterController);
export { Bar, Bubble, Chart, Doughnut, Line, Pie, PolarArea, Radar, Scatter, getDatasetAtEvent, getElementAtEvent, getElementsAtEvent };